function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 5.74v12.52c0 2.06-1.68 3.74-3.74 3.74h-.52C15.68 22 14 20.32 14 18.26v-6.38c.35-.04.69-.09 1.01-.16 2.04-.37 3.59-1.07 4.71-1.78 1.44-.9 2.28-2.5 2.28-4.2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 5.74c0 1.7-.84 3.3-2.28 4.2-1.12.71-2.67 1.41-4.71 1.78-.32.07-.66.12-1.01.16v.75c-1.19.15-2.46.07-3.93.22l-.07.01v5.4C10 20.32 8.32 22 6.26 22h-.52C3.68 22 2 20.32 2 18.26c0-.09 0-.19.02-.28.08-1.6.9-3.07 2.26-3.92 1.12-.71 2.67-1.41 4.7-1.78.32-.07.67-.12 1.02-.16v-.77c1.56-.14 2.75-.06 3.91-.21l.09-.01V5.74C14 3.68 15.68 2 17.74 2h.52A3.747 3.747 0 0122 5.74z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 5.74v6.38c-.35.04-.7.09-1.02.16-2.03.37-3.58 1.07-4.7 1.78-1.36.85-2.18 2.32-2.26 3.92L2 18V5.74C2 3.68 3.68 2 5.74 2h.52C8.32 2 10 3.68 10 5.74z"
})));